import { isObject } from "lodash";

/**
 * 校验
 * @param {object} target 目标
 */
export const validate = (field) => {
  if (!field || !isObject(field)) {
    return {
      success: false,
      errorMsg: `${field} 影响字段须为对象`,
    };
  }

  const { id, prop } = field;
  if (!id) {
    return {
      success: false,
      errorMsg: `${field} 影响字段缺少 id`,
    };
  }
  if (!prop) {
    return {
      success: false,
      errorMsg: `${field} 影响字段缺少 prop`,
    };
  }

  return {
    success: true,
    errorMsg: "",
  };
};

/**
 * 解析目标字段
 * @param {string} field 目标字段
 * @return {object} { event, handler }
 */
export const parse = (field, options = {}) => {
  const { fieldApi } = options;

  const validateResult = validate(field);
  console.warn(validateResult.success, validateResult.errorMsg);

  const { id: fieldId, prop } = field;
  const fieldsShouldReset = []; // 值需要重置的字段
  // 选项更新，字段的值需要重置
  if (prop.indexOf("options") !== -1 || prop.indexOf("Options") !== -1) {
    fieldsShouldReset.push(fieldId);
  }

  return {
    preHandler: () => {
      // 滤除未在页面显示的字段
      if (!fieldApi.isFieldExist(fieldId)) return;
      const componentName = fieldApi.getComponentName(fieldId);

      switch (prop) {
        // 设置选项，预先重置
        case "dataSource.options":
        case "options":
          if (componentName === "CascadeSelect") {
            fieldApi.setFieldProps(fieldId, {
              hasError: false,
              errorMsg: "",
            });
          } else {
            fieldApi.setFieldProps(fieldId, {
              [prop]: [],
              hasError: false,
              errorMsg: "",
            });
          }
          break;
        case "value":
          fieldApi.setFieldProps(fieldId, {
            hasError: false,
            errorMsg: "",
          });
          break;
        default:
          break;
      }
    },

    handler: (data = {}) => {
      // 滤除未在页面显示的字段
      if (!fieldApi.isFieldExist(fieldId)) return;

      const { res: value, failed } = data;
      fieldApi.setFieldProps(
        fieldId,
        { [prop]: value, failed: !!failed },
        {
          fieldsShouldReset,
        }
      );
    },
  };
};
